import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsStockInfoHeroContentSectionHeaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Stock Info Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsStockInfoHeroContentSectionHeaderCls || '', 'investors_stock_info_hero', { animCls: 'animate__fadeInDown', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;